// ** React Imports
import {Link} from 'react-router-dom'

// ** Custom Components
// ** Store & Actions
import {useDispatch} from 'react-redux'
import {handleLogout} from '@store/authentication'

// ** Third Party Components
import {Power, Settings, User} from 'react-feather'

// ** Reactstrap Imports
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from 'reactstrap'
import {useTranslation} from "react-i18next"
import {logout} from "../../../../services/AuthService"

const UserDropdown = () => {
    // ** Store Vars
    const dispatch = useDispatch()
    const {t} = useTranslation()

    return (
        <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
            <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
                <User/>
            </DropdownToggle>
            <DropdownMenu end>
                <DropdownItem tag={Link} to='/user/account'>
                    <Settings size={14} className='me-75'/>
                    <span className='align-middle'>{t('navbar.settings')}</span>
                </DropdownItem>
                <DropdownItem tag={Link} to='/login' onClick={() => {
                    dispatch(handleLogout())
                    logout()
                }}>
                    <Power size={14} className='me-75'/>
                    <span className='align-middle'>{t('navbar.logout')}</span>
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}

export default UserDropdown
